/**
 * 格式化金额
 * @param {number} amount - 要格式化的金额
 * @param {number} decimals - 小数点后保留的位数，默认为2
 * @param {string} decimalSeparator - 小数点分隔符，默认为"."
 * @param {string} thousandSeparator - 千分位分隔符，默认为","
 * @returns {string} 格式化后的金额字符串
 */
export function formatAmount(
	amount: number | null,
	{
		decimals = 2,
		decimalSeparator = ".",
		thousandSeparator = ",",
		isThousand = false,
	}:
		| {
				decimals?: number
				decimalSeparator?: string
				thousandSeparator?: string
				isThousand?: boolean
		  }
		| undefined = {},
): string {
	// 确保amount是一个数字
	if (!amount || Number.isNaN(amount)) return "0.00"
	// 如果是千位，需要除以100
	if (isThousand) {
		amount = amount / 100
	}
	// 固定小数位数
	const fixedAmount = Number(amount).toFixed(decimals)

	// 分割整数部分和小数部分
	const parts = fixedAmount.split(".")
	const integerPart = parts[0]!
	const decimalPart = parts.length > 1 ? decimalSeparator + parts[1] : ""

	// 添加千分位分隔符
	const formattedIntegerPart = integerPart.replace(
		/\B(?=(\d{3})+(?!\d))/g,
		thousandSeparator,
	)

	return formattedIntegerPart + decimalPart
}
